import type { FindingCategory } from "./Finding";

// id секции категории: на неё ведёт плитка «светофора».
export const categoryAnchor = (category: FindingCategory): string => `analysis-${category}`;
